export const FETCH_RESTAURANT_TIMING_REQUEST = 'FETCH_RESTAURANT_TIMING_REQUEST'
export const FETCH_RESTAURANT_TIMING_SUCCESS = 'FETCH_RESTAURANT_TIMING_SUCCESS'
export const FETCH_RESTAURANT_TIMING_FALIURE = 'FETCH_RESTAURANT_TIMING_FALIURE'
